import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

import Home from './pages/Home';
import FileUploadPage from './pages/FileUploadPage';
import BookingFormPage from './pages/BookingFormPage';
import ConsultationBookingPage from './pages/ConsultationBookingPage';

import ConsultationRouter from './pages/ConsultationRouter';

import Subscription1 from './components/Subscription/Subscription1';
import Subscription2 from './components/Subscription/Subscription2';
import PackageBooking from './components/Package/PackageBooking';

import './App.css';

function App() {
  return (
    <Router basename="/consultation">
      <div className="App">

        <Header />

        <main>
          <Routes>

            {/* Home */}
            <Route path="/" element={<Navigate to="/consultation" />} />

            {/* Consultation controller */}
            <Route path="/consultation" element={<ConsultationRouter />} />

            {/* Direct booking form route (optional) */}
            <Route path="/booking-form" element={<BookingFormPage />} />

            {/* Upload page */}
            <Route path="/upload-file" element={<FileUploadPage />} />

            {/* Consultation booking */}
            <Route path="/consultation-booking" element={<BookingFormPage />} />

            {/* Packages */}
            <Route path="/package" element={<PackageBooking />} />

            {/* Subscriptions */}
            <Route path="/subscription1" element={<Subscription1 />} />
            <Route path="/subscription2" element={<Subscription2 />} />

          </Routes>
        </main>

        <Footer />

      </div>
    </Router>
  );
}

export default App;